import TextField from '@mui/material/TextField';

export const MyMTextBox = (props) => {
  const {
    inputValue,
    size,
    fontSize,
    width,
    height,
    color,
    maxLength,
    disabled,
    textAlign,
    // 2025.3.5 MyMine Version2.1対応 Add Start
    inputProps,
    sx,
    // 2025.3.5 MyMine Version2.1対応 Add End
    ...other } = props;
  return (
    <TextField
      value={inputValue ?? ''}
      inputProps={{
        maxLength: maxLength,
        sx: {
          fontSize: fontSize ?? '1rem',
          color: color ?? '#000',
          textAlign: textAlign
        },
        // 2025.3.5 MyMine Version2.1対応 Add Start
        ...inputProps
        // 2025.3.5 MyMine Version2.1対応 Add End
      }}
      sx={{
        width: width,
        height: height ?? '40px',
        'input': {
          backgroundColor: (disabled) && '#E9ECEF',
          marginTop: (disabled) && '1px',
        },
        // 2025.3.5 MyMine Version2.1対応 Add Start
        ...sx
        // 2025.3.5 MyMine Version2.1対応 Add End

      }}
      size={size ?? 'small'}
      disabled={disabled}
      {...other}
    />
  )
};
